var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4165 74.6031C72.2376 104.35 93.5928 66.3003 93.5614 43.4186C93.5243 16.3648 66.1039 1.24463 50.3987 1.24463C25.1903 1.24463 1.18359 22.0784 1.18359 50.5832C1.18359 82.2665 28.7024 99.8163 50.3987 99.8163C45.4889 99.1094 29.1271 95.6035 28.9072 57.9179C28.7594 32.4295 37.2217 22.2464 50.3631 26.7258C50.6574 26.835 64.8584 32.437 64.8584 50.7371C64.8584 68.9594 50.4165 74.6031 50.4165 74.6031V74.6031V74.6031Z",
    fill: "url(#paint0_linear_30_455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3911 26.7053C35.9722 21.7355 18.3089 33.6194 18.3089 57.4226C18.3089 96.2888 47.11 99.8164 50.6014 99.8164C75.8097 99.8164 99.8164 78.9826 99.8164 50.4779C99.8164 18.7945 72.2977 1.2447 50.6014 1.2447C56.6107 0.412489 82.9905 7.74825 82.9905 43.8028C82.9905 67.3151 63.293 80.115 50.4814 74.6462C50.1871 74.537 35.9861 68.935 35.9861 50.6349C35.9861 32.4125 50.3911 26.7053 50.3911 26.7053V26.7053V26.7053Z",
    fill: "url(#paint1_linear_30_455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_455",
    x1: -12.8246,
    y1: 57.0738,
    x2: 60.2521,
    y2: 113.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_455",
    x1: 104.861,
    y1: 32.1927,
    x2: 29.6137,
    y2: -2.89853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/JSON.f55776c4e7d0f824d9b6ce5633b73603.svg";
export { ForwardRef as ReactComponent };